import "./RefundAndReturnsPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Refund from "./sections/Refund";
import Footer from "@/reusable_sections/Footer";
export default function RefundAndReturnsPolicyPage() {
  return <div>
      <Header />
      <Refund />
      <Footer />
    </div>;
}